export default __webpack_public_path__ + "static/media/home_rect.8df91e1c.svg";